import LegalPage from "@/components/LegalPage";

const SECTIONS = [
    {
        title: "Éditeur du site",
        paragraphs: [
            "Le présent site est édité sous la marque ERADIKBREIZH, exploitée par la société ABITA MULTISERVICES, EURL (Société à responsabilité limitée à associé unique) au capital social de 2 500 €, immatriculée au Registre du Commerce et des Sociétés de Rennes sous le numéro 100 801 877 RCS Rennes, numéro EUID FR3501.100801877.",
            "Siège social : 5 Allée de la Grande Treille, Bureau 3, 35000 Rennes",
            "Téléphone : 02 55 99 22 43",
            "Adresse email : contact@eradikbreizh.fr",
        ],
    },
    {
        title: "Hébergement",
        paragraphs: [
            "Ce site est hébergé par la société IONOS.",
        ],
    },
    {
        title: "Données personnelles",
        paragraphs: [
            "Les données collectées sur notre site sont destinées à eradikbreizh.fr. Elles sont strictement confidentielles et conservées à des fins de gestion de nos relations commerciales, de prospection et de statistiques, et ont fait l'objet d'une déclaration auprès de la CNIL.",
            "Conformément aux dispositions de la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données qui vous concernent, en écrivant à contact@eradikbreizh.fr.",
            "Notre base de données, pouvant contenir des données personnelles, est déclarée auprès de la Commission Nationale Informatique et Libertés (CNIL). À chaque collecte de données à caractère personnel sur le site, les conditions juridiques de collecte et/ou de modification des données sont expressément rappelées.",
        ],
    },
    {
        title: "Conditions d'utilisation",
        paragraphs: [
            "Ce site est soumis à la loi française. En consultant ce site, vous acceptez d'en respecter les conditions d'utilisation telles qu'elles sont affichées à la date de consultation.",
        ],
    },
    {
        title: "Objet du site",
        paragraphs: [
            "Le présent site diffuse des informations contractuelles et non contractuelles sur les offres de services d'Eradikbreizh. Dans la mesure où la mise à jour du site est réalisée en tenant compte de l'ensemble des activités de la société, il pourrait arriver que certaines informations nouvelles ou annoncées ne soient plus valables au moment de leur diffusion ou qu'elles soient tout simplement dépassées. Eradikbreizh ne peut pas garantir, bien qu'elle fasse les efforts nécessaires, la parfaite mise à jour de toutes les informations diffusées sur le présent site.",
        ],
    },
    {
        title: "Propriété intellectuelle",
        paragraphs: [
            "Le contenu de ce site, incluant son architecture, textes, photos, illustrations et logiciels, appartient à eradikbreizh.fr ou à ses partenaires techniques. Certaines images ou signes distinctifs peuvent être protégés en tant que propriété intellectuelle. Les marques et logos présents sur ce site sont déposés ; leur reproduction constituerait une contrefaçon.",
            "Tous droits d'utilisation sont réservés. Selon l'article L.122-4 du Code de la Propriété Intellectuelle, toute représentation ou reproduction non explicitement autorisée, qu'elle soit intégrale ou partielle, est illicite et constitue une contrefaçon, punie conformément aux articles L.335-2 et suivants du même code.",
        ],
    },
    {
        title: "Les liens",
        paragraphs: [
            "Eradikbreizh peut proposer des liens vers des sites externes. Ces derniers sont indépendants et ne sont pas sous le contrôle d'Eradikbreizh. Par conséquent, nous ne cautionnons ni n'approuvons le contenu de ces sites. Eradikbreizh ne peut être tenu responsable du contenu ou des éléments associés à ces sites, y compris les dommages potentiels liés à leur utilisation.",
        ],
    },
    {
        title: "Responsabilité",
        paragraphs: [
            "Ni Eradikbreizh, ni ses dirigeants ou employés ne peuvent être tenus responsables de dommages résultant de l'utilisation de ce site. Nous nous réservons le droit de modifier, suspendre ou interrompre tout ou partie de ce site, y compris les liens ou les communications entre utilisateurs. Les utilisateurs s'engagent à ne pas introduire, volontairement ou non, de contenu nuisible sur le site. En cas de non-respect, ils en assumeront l'entière responsabilité et Eradikbreizh pourra prendre des mesures judiciaires à leur encontre.",
            "Pour certaines opérations, vous pourriez être invité à fournir des informations. Ces données, si elles sont communiquées, seront utilisées exclusivement par Eradikbreizh et ne seront pas partagées avec des tiers, sauf si ces derniers contribuent au fonctionnement du site. Nous nous engageons à mettre en œuvre toutes les mesures nécessaires pour garantir la confidentialité de vos données.",
        ],
    },
    {
        title: "Médiation",
        paragraphs: [
            "En cas de litige entre le Client et l'entreprise, les parties s'efforceront de le résoudre à l'amiable. Le Client adressera une réclamation écrite au professionnel.",
            "À défaut d'accord amiable ou en l'absence de réponse dans un délai d'un (1) mois, le Client consommateur, au sens de l'article L.133-4 du Code de la consommation, peut saisir gratuitement le médiateur de la consommation compétent : CM2C, Centre de la Médiation de la Consommation de Conciliateurs de Justice.",
            "En cas de litige de la consommation, vous pouvez le déclarer directement sur la plateforme CM2C : www.cm2c.net",
            "Adresse : 49 rue de Ponthieu, 75008 Paris. Email : contact@cm2c.net. Téléphone : 01 89 47 00 14.",
        ],
        image: {
            src: "/assets/cm2c.png",
            alt: "CM2C : Centre de la Médiation de la Consommation de Conciliateurs de Justice",
            href: "https://www.cm2c.net",
        },
    },
];

const MentionsLegales = () => (
    <LegalPage
        testid="mentions-legales-page"
        tag="Informations légales"
        title="Mentions"
        accent="légales"
        intro="Éditeur, hébergement, propriété intellectuelle, conditions d'utilisation et médiation : toutes les informations légales relatives au site eradikbreizh.fr."
        sections={SECTIONS}
        seoTitle="Mentions légales | Eradikbreizh"
        seoDescription="Mentions légales du site eradikbreizh.fr : ABITA MULTISERVICES EURL, RCS Rennes 100 801 877, siège 5 Allée de la Grande Treille, 35000 Rennes. Hébergeur IONOS, propriété intellectuelle et médiation."
    />
);

export default MentionsLegales;
